import { render, staticRenderFns } from "./Terminals.vue?vue&type=template&id=39c8b923&scoped=true"
import script from "./Terminals.vue?vue&type=script&lang=js"
export * from "./Terminals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8b923",
  null
  
)

export default component.exports